import { useQueryClient as rqUseQueryClient } from 'react-query';
export const useQueryClient = rqUseQueryClient;
//# sourceMappingURL=useQueryClient.js.map